/* ===========================================================================
   Nintara — Diaper Bag FAQs
   File: assets/diaper-bag-faqs.js   (loaded with `defer`)

   Replaces pdp-accordion-control.js for this page. The old markup gave the
   heading and its panel the SAME id, which is invalid HTML and means
   getElementById can only ever reach the first of the pair. Here each item is
   self-contained: the script walks up from the clicked button to its own
   [data-nbf-item], so nothing is matched by id at all.

   PROGRESSIVE ENHANCEMENT
   Panels are open in the markup and only collapse once this script sets
   data-enhanced="true" on the root. With JS blocked or still loading, every
   answer is readable and indexable rather than sealed shut.

   MULTI-INSTANCE
   Generic over every [data-nbf] root, so the section can be added twice (one
   per bag type) with no per-instance code.
   =========================================================================== */

(function () {
  'use strict';

  if (window.__nintaraFaqsLoaded) return;
  window.__nintaraFaqsLoaded = true;

  function initRoot(root) {
    if (!root || root.__nbfInit) return;
    root.__nbfInit = true;

    var closeOthers = root.getAttribute('data-close-others') === 'true';
    var trackingId  = root.getAttribute('data-tracking-id') || '';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-nbf-item]'));
    if (!items.length) return;

    /* Collapse everything the CSS is now allowed to collapse. Doing this from
       JS — not in the markup — is what keeps the no-JS state readable. */
    root.setAttribute('data-enhanced', 'true');

    function setOpen(item, open) {
      var btn   = item.querySelector('[data-nbf-toggle]');
      var panel = item.querySelector('[data-nbf-panel]');
      if (!btn || !panel) return;

      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      /* inert-style hiding without `hidden`, which would kill the transition */
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    items.forEach(function (item) {
      setOpen(item, item.hasAttribute('data-open-on-load'));
    });

    root.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('[data-nbf-toggle]');
      if (!btn || !root.contains(btn)) return;

      var item = btn.closest('[data-nbf-item]');
      if (!item) return;

      var willOpen = !item.classList.contains('is-open');

      if (willOpen && closeOthers) {
        items.forEach(function (other) {
          if (other !== item) setOpen(other, false);
        });
      }

      setOpen(item, willOpen);

      /* Which questions get opened is the most useful signal this section
         produces — it tells you what people are unsure about before buying. */
      if (willOpen) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'nintara_faq_open',
          faq_question: (btn.textContent || '').trim(),
          faq_index: items.indexOf(item) + 1,
          bag_type: root.getAttribute('data-bag-type') || '',
          tracking_id: trackingId
        });
      }
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-nbf]')).forEach(initRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
